/* eslint-disable max-len */
export default {
  error: {
    default: 'An error occurred',
    unauthorized: 'You don\'t have access to view this site.',
    unauthorizedAction: 'You don\'t have the appropriate access rights for this action.',
    userExists: 'User already exists',
    sessionExpired: 'Your session has expired. Please login again.',
    emailNotRegistered: 'This email is not registered.',
    emailNotMatching: 'The emails do not match.',
    duringCopying: 'Error during copying',
    lastAdmin: 'This user cannot be deleted because it is the last remaining admin. First assign another admin, then you can delete it.',
    invalidDateFormat: 'Date format is not valid',
    invalidDateRange: 'Date range is not valid',
    dateOutOfRange: 'Time is outside the allowed period',
    notAnImage: 'Only images are allowed.',
    pageExport: 'Export failed. Please try again.',
  },
  success: {
    created: 'Successfully created',
    updated: 'Successfully updated',
    added: 'Successfully added',
    deleted: 'Successfully deleted',
    deactivated: 'Successfully deactivated',
    paused: 'Successfully paused',
    archived: 'Successfully archived',
    restored: 'Successfully restored',
    reactivated: 'Successfully reactivated',
    movedToTrash: 'Moved to trash',
    saved: 'Successfully saved',
    duplicated: 'Successfully duplicated',
    copied: 'Successfully copied',
    sent: 'Successfully sent',
  },
  general: {
    none: 'None',
    yes: 'Yes',
    cancel: 'Cancel',
    okay: 'Okay',
    archive: 'Archive',
    continue: 'Continue',
    typeWorkspaceNameToProceed: 'Type the workspace name to proceed',
    deactivate: 'Deactivate',
    delete: 'Delete',
    deletePermanently: 'Delete permanently',
    dangerZone: 'Danger zone',
    restore: 'Restore',
    reactivate: 'Reactivate',
    search: 'Search',
    typeToSearch: 'Type to search...',
    noResults: 'No results',
    add: 'Add',
    create: 'Create',
    update: 'Update',
    save: 'Save',
    saved: 'Saved',
    submit: 'Submit',
    invite: 'Invite',
    confirm: 'Confirm',
    send: 'Send',
    edit: 'Edit',
    apply: 'Apply',
    view: 'View',
    back: 'Back',
    close: 'Close',
    empty: 'Empty',
    reset: 'Reset',
    email: 'Email',
    workMail: 'Work email',
    rename: 'Rename',
    password: 'Password',
    and: 'and',
    or: 'or',
    retry: 'Retry',
    settings: 'Settings',
    change: 'Change',
    preview: 'Preview',
    status: 'Status',
    active: 'Active',
    inactive: 'Inactive',
    share: 'Share',
    public: 'Public',
    private: 'Private',
    custom: 'Custom',
    loadMore: 'Load more',
    Settings: 'Settings',
    yesDelete: 'Yes, delete',
    yesRemove: 'Yes, remove',
    yesUpdate: 'Yes, update',
    yesDisconnect: 'Yes, disconnect',
    yesDiscard: 'Yes, discard',
    yesDeactivate: 'Yes, deactivate',
    yesPause: 'Yes, pause',
    undo: 'Undo',
    new: 'New',
    show: 'Show',
    remove: 'Remove',
    feed: 'Feed',
    list: 'List',
    createdAt: 'Created at',
    modifiedAt: 'Modified at',
    creator: 'Creator',
    title: 'Title',
    actions: 'Actions',
    all: 'All',
    any: 'Any',
    duplicate: 'Duplicate',
    moreActions: 'More actions',
    download: 'Download',
    notFound: 'Not found',
    deletePrompt: 'Are you sure you want to delete this?',
    emptyList: 'No elements available',
    noEntries: 'No entries yet',
    open: 'Open',
    hide: 'Hide',
    select: 'Select',
    discardChanges: 'Discard changes',
    skip: 'Skip',
    discardEditPrompt: 'Do you want to discard your unsaved changes?',
    untitled: 'Untitled',
    loading: 'loading',
    value: 'Value',
    copy: 'Copy',
    learnMore: 'Learn more',
    supportEmail: 'support{\'@\'}mooncamp.com',
    websiteBaseUrl: 'https://mooncamp.com',
    helpCenterBaseUrl: 'https://mooncamp.com/docs',
    default: 'Default',
    exporting: 'Exporting...',
    at: 'at',
    unknown: 'Unknown',
    more: 'more',
  },
  validation: {
    invalidEmail: 'This is not a valid email',
    required: 'This value is required',
    notEmpty: 'This value cannot be empty',
    minLengthEightChars: 'Minimum of 8 characters',
    textTooLong: 'This text is too long',
    biggerThanZero: 'Must be greater than 0',
    lessThan50Chars: 'Must be less than 50 characters',
  },
  submitArea: { send: 'Submit my answer' },
  successView: {
    goToHomescreen: 'Back to the app',
    thankYou: 'Thank you for your feedback!',
  },
  user: {
    bot: {
      firstName: 'Mooncamp',
      lastName: 'Bot',
      name: '@:{\'user.bot.firstName\'} @:{\'user.bot.lastName\'}',
    },
    deleted: {
      firstName: 'Deleted',
      lastName: 'user',
      name: '@:{\'user.deleted.firstName\'} @:{\'user.deleted.lastName\'}',
    },
  },
  userPicker: {
    placeholder: 'Search Name',
    noData: 'No users found',
    description: 'Pick a person',
  },
  page: { addEmoji: 'Add icon' },
  mSelect: {
    pickAnItem: 'Pick an item',
    searchPlaceholder: 'Search for an option...',
    noItems: 'No items available',
    placeholder: 'Empty',
    title: 'Pick an item',
    create: 'Create',
    more: 'more',
  },
  time: {
    weeksAgo: 'one week ago | {count} weeks ago',
    date: '{dateTime}',
    daysAgo: 'yesterday | {count} days ago',
    hoursAgo: 'one hour ago | {count} hours ago',
    minutesAgo: 'a minute ago | {count} minutes ago',
    inWeeks: 'in one week | in {count} weeks',
    inDays: 'tomorrow | in {count} days',
    inHours: 'in one hour | in {count} hours',
    inMinutes: 'in a minute | in {count} minutes',
  },
  timeZonePicker: {
    timeZone: 'Time zone',
    placeholder: 'Search for a time zone...',
    prompt: 'Select a time zone',
  },
  mDatePicker: {
    title: 'Pick a date',
    timePicker: 'Time included',
    startDate: 'Start date',
    endDate: 'End date',
    empty: 'Empty',
    month: {
      1: 'January',
      2: 'February',
      3: 'March',
      4: 'April',
      5: 'May',
      6: 'June',
      7: 'July',
      8: 'August',
      9: 'September',
      10: 'October',
      11: 'November',
      12: 'December',
    },
    monthShort: {
      1: 'Jan',
      2: 'Feb',
      3: 'Mar',
      4: 'Apr',
      5: 'May',
      6: 'Jun',
      7: 'Jul',
      8: 'Aug',
      9: 'Sep',
      10: 'Oct',
      11: 'Nov',
      12: 'Dec',
    },
    weekdays: {
      1: 'Monday',
      2: 'Tuesday',
      3: 'Wednesday',
      4: 'Thursday',
      5: 'Friday',
      6: 'Saturday',
      7: 'Sunday',
    },
  },
  mUrlField: { openLink: 'Open link', copyLink: 'Copy link' },
  mTable: {
    search: 'Enter {title}...',
    noData: 'No data available',
    count: 'Count',
  },
  actions: {
    drag: 'Drag',
    toRealign: ' to move',
    click: 'Click',
    toSeeActions: ' to see actions',
  },
};
